import { acceptBooleanValue } from '../../field-viewer/shared-normalizers';
export const dextCheckboxViewer = {
    normalizeLoadedValue: acceptBooleanValue
};

//# sourceMappingURL=definition-viewer.js.map